import { AnnotationUtil } from './AnnotationUtil';
const DOM_MODE_APPEND = 'append';
const DOM_MODE_INSERT = DOM_MODE_APPEND;
export class AnnotationRenderer {
    /**
     * Constructor
     * @param {HTMLElement} element
     * @param {Array.<Annotation>} annotations
     * @param {AnnotationHelper} helper
     */
    constructor(element, annotations, helper) {
        this.element = element;
        this.annotations = annotations;
        this.helper = helper;
        this.canvas = null;
        this.context = null;
        this.width = 0;
        this.height = 0;
        if (!this.element) {
            return;
        }
        if (this.element.tagName === 'CANVAS') {
            this._reuseCanvas();
        }
        else {
            this.domMode = DOM_MODE_INSERT;
            this._createCanvas();
            this.resize();
        }
    }
    /**
     * Create the canvas for the renderer
     */
    _createCanvas() {
        this.canvas = AnnotationUtil.createCanvasForElement(this.element, this.helper.options.devicePixelRatio, this.helper.options.append, this.domMode === DOM_MODE_INSERT);
        this.canvas.className += ' annotation-renderer';
        this.context = this.canvas.getContext('2d');
    }
    _reuseCanvas() {
        this.canvas = this.element;
        this.canvas.className += ' annotation-renderer';
        this.context = this.canvas.getContext('2d');
        const rect = this.canvas.getBoundingClientRect();
        this.width = rect.width * this.helper.options.devicePixelRatio;
        this.height = rect.height * this.helper.options.devicePixelRatio;
    }
    resize() {
        const rect = this.element.getBoundingClientRect();
        this.width = rect.width * this.helper.options.devicePixelRatio;
        this.height = rect.height * this.helper.options.devicePixelRatio;
        this.canvas.width = rect.width * this.helper.options.devicePixelRatio;
        this.canvas.height = rect.height * this.helper.options.devicePixelRatio;
        let canvasTop = '0';
        let canvasLeft = '0';
        if (this.canvas !== this.element) {
            if (this.domMode !== DOM_MODE_INSERT) {
                canvasTop = `${this.element.offsetTop}px`;
                canvasLeft = `${this.element.offsetLeft}px`;
            }
            this.canvas.style.width = `${rect.width}px`;
            this.canvas.style.height = `${rect.height}px`;
            this.canvas.style.top = canvasTop;
            this.canvas.style.left = canvasLeft;
        }
        // Call method implemented by specific renderer
        this.render();
    }
    destroy() {
        this._destroyCanvas();
    }
    /**
     * Destroy canvas + references
     */
    _destroyCanvas() {
        this.context = null;
        this.element.parentNode.removeChild(this.canvas);
        this.canvas = null;
    }
    /**
     * Clear the canvas
     */
    clear() {
        if (this.context) {
            this.context.clearRect(0, 0, this.width, this.height);
        }
    }
    /**
     * Get annotation data from renderer
     * @returns {Array.<Annotation>}
     */
    getAnnotations() {
        return this.annotations;
    }
    /**
     * Update annotations for renderer
     * @param {Array.<Annotation>} annotations
     * @returns {AnnotationRenderer}
     */
    setAnnotations(annotations = []) {
        this.annotations = annotations;
        return this;
    }
}
//# sourceMappingURL=AnnotationRenderer.js.map